import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedTeamOptionParentList = ({
  name,
  fullParentNameList
}) => {
  if (fullParentNameList.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Small, {
    children: [...fullParentNameList, name].join(' > ')
  });
};
const SelectedTeamOption = ({
  id,
  name,
  totalTeamMembers,
  fullParentNameList,
  onRemoveTeam,
  userCanRemoveTeam
}) => {
  return /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
    style: {
      height: '70px'
    },
    children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
      className: "p-y-0",
      children: /*#__PURE__*/_jsxs("div", {
        className: "align-center",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "lists",
          size: "medium",
          className: "m-right-4"
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ui-asset-management-lib.assetAccessPanel.teamMembers",
              options: {
                teamName: name,
                totalTeamMembers
              }
            })
          }), /*#__PURE__*/_jsx(SelectedTeamOptionParentList, {
            name: name,
            fullParentNameList: fullParentNameList
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
      children: userCanRemoveTeam && /*#__PURE__*/_jsx(UIIconButton, {
        "data-test-id": `remove-team-button-${id}`,
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.tooltips.removeTeam"
        }),
        size: "extra-small",
        use: "transparent",
        onClick: () => onRemoveTeam(id),
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "remove"
        })
      })
    })]
  });
};
SelectedTeamOption.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  totalTeamMembers: PropTypes.number.isRequired,
  fullParentNameList: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRemoveTeam: PropTypes.func.isRequired,
  userCanRemoveTeam: PropTypes.bool.isRequired
};
export default SelectedTeamOption;